import { mapState } from 'vuex';
export default {
  name: 'ViewAlarmLogsReportList',
  props: {},
  data() {
    return {};
  },
  computed: {
    ...mapState('app', ['color'])
  },
  methods: {}
};